module.exports = __webpack_public_path__ + "img/merchant-car-imgbg2.ae5d7925.png";